const MIN_SCALE = 1.0;
const MAX_SCALE = 5.0;
const EPSILON = 0.001;

export { MIN_SCALE, MAX_SCALE, EPSILON };

export function clampScale(proposed: number): number {
  "worklet";
  return Math.min(MAX_SCALE, Math.max(MIN_SCALE, proposed));
}

export function isEffectivelyAtMinScale(scale: number): boolean {
  "worklet";
  return scale <= MIN_SCALE + EPSILON;
}

export interface ClampedTranslation {
  x: number;
  y: number;
}

export function clampTranslation(
  scale: number,
  translateX: number,
  translateY: number,
  viewWidth: number,
  viewHeight: number,
): ClampedTranslation {
  "worklet";
  if (viewWidth <= 0 || viewHeight <= 0 || isEffectivelyAtMinScale(scale)) {
    return { x: 0, y: 0 };
  }
  const maxX = Math.max(0, (viewWidth * scale - viewWidth) / 2);
  const maxY = Math.max(0, (viewHeight * scale - viewHeight) / 2);
  return {
    x: Math.min(maxX, Math.max(-maxX, translateX)),
    y: Math.min(maxY, Math.max(-maxY, translateY)),
  };
}
